<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="900">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-METRIC' : 'EDIT-METRIC') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm" class="k-form">
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NAME' | translate}} *
                    </span>
                    <input id="name" kendoTextBox formControlName="name" maxlength="100" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="name.hasError('required') && name.touched">
                        {{'REQUIRED-NAME' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="name.hasError('nameExists')">
                        {{'METRIC-ALREADY-EXISTS' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label for="description" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'DESCRIPTION' | translate }} *
                    </span>
                    <textarea id="description" kendoTextArea class="w-100 k-textarea" rows="2"
                        formControlName="description" maxlength="1024" style="max-height: 300px;">
                    </textarea>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="description.hasError('required') && description.touched">
                        {{'REQUIRED-DESCRIPTION' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <!--Metric Type-->
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'TYPE' | translate}} *
                    </span>
                    <div>
                        <span>
                            <input type="radio" value="RATE_BASED" name="metricType" formControlName="metricType"
                                id="radioRateBased" kendoRadioButton />
                            <label class="k-radio-label" for="radioRateBased">{{'METRIC-TYPE-RATE' | translate}}
                            </label>
                        </span>
                        <span>
                            <input type="radio" value="COUNT_BASED" name="metricType" formControlName="metricType"
                                id="radioCountBased" kendoRadioButton />
                            <label class="k-radio-label" for="radioCountBased">{{'METRIC-TYPE-COUNT' | translate}}
                            </label>
                        </span>
                    </div>
                </label>
            </div>
            <!--Metric Rate Mode-->
            <div class="col-6" *ngIf="metricType.value === 'RATE_BASED'">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'RATE-MODE' | translate}} *
                    </span>
                    <div>
                        <span>
                            <input type="radio" value="CALCULATED" name="metricRateMode"
                                formControlName="metricRateMode" id="radioRateModeCalculated" kendoRadioButton />
                            <label class="k-radio-label" for="radioRateModeCalculated">{{'RATE-MODE-CALCULATED' |
                                translate}}
                            </label>
                        </span>
                        <span>
                            <input type="radio" value="MANUAL" name="metricRateMode" formControlName="metricRateMode"
                                id="radioRateModeManual" kendoRadioButton />
                            <label class="k-radio-label" for="radioRateModeManual">{{'RATE-MODE-MANUAL' | translate}}
                            </label>
                        </span>
                    </div>
                </label>
            </div>
        </div>
        <!--Numerator Description-->
        <div class="row">
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NUMERATOR-DESCRIPTION' | translate}} *
                    </span>
                    <input id="numeratorDescription" kendoTextBox formControlName="numeratorDescription"
                        maxlength="100" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="numeratorDescription.hasError('required') && numeratorDescription.touched">
                        {{'REQUIRED-NUMERATOR-DESCRIPTION' | translate}}
                    </div>
                </label>
            </div>
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NUMERATOR' | translate}} <span style="display: inline-flex">
                            <div #tipA kendoTooltip position="top" class="keyboard-accessible" tabindex="0"
                                showOn="none" (focus)="showTooltip(numDenomTooltipA,tipA)" aria-live="polite"
                                (mouseover)="showTooltip(numDenomTooltipA,tipA)" (blur)="hideTooltip(tipA)"
                                (mouseout)="hideTooltip(tipA)">
                                <a #numDenomTooltipA title="{{'INFO-NUMERATOR-DENOMINATOR' | translate}}"><i
                                        class="fa fa-info-circle pointer"></i>
                                </a>
                            </div>
                        </span>
                    </span>
                    <kendo-combobox name="numerator" formControlName="numerator" class="w-100" [valuePrimitive]="false"
                        [data]="metricsLookup" [textField]="'name'" [valueField]="'id'">
                    </kendo-combobox>
                </label>
            </div>
        </div>
        <!--Denominator Description-->
        <div class="row">
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'DENOMINATOR-DESCRIPTION' | translate}} *
                    </span>
                    <input id="denominatorDescription" kendoTextBox formControlName="denominatorDescription"
                        maxlength="100" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="denominatorDescription.hasError('required') && denominatorDescription.touched">
                        {{'REQUIRED-DENOMINATOR-DESCRIPTION' | translate}}
                    </div>
                </label>
            </div>
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'DENOMINATOR' | translate}} <span style="display: inline-flex">
                            <div #tipB kendoTooltip position="top" class="keyboard-accessible" tabindex="0"
                                showOn="none" (focus)="showTooltip(numDenomTooltipB,tipB)" aria-live="polite"
                                (mouseover)="showTooltip(numDenomTooltipB,tipB)" (blur)="hideTooltip(tipB)"
                                (mouseout)="hideTooltip(tipB)">
                                <a #numDenomTooltipB title="{{'INFO-NUMERATOR-DENOMINATOR' | translate}}"><i
                                        class="fa fa-info-circle pointer"></i>
                                </a>
                            </div>
                        </span>
                    </span>
                    <kendo-combobox name="denominator" formControlName="denominator" class="w-100"
                        [valuePrimitive]="false" [data]="metricsLookup" [textField]="'name'" [valueField]="'id'">
                    </kendo-combobox>
                </label>
            </div>
        </div>
        <label class="k-text-uppercase dark mr-2 pt-2 w-100" for="active">{{ 'ENABLED' | translate }}</label>
        <kendo-switch formControlName="active" onLabel="{{'YES' | translate }}" offLabel="{{'NO' | translate }}">
        </kendo-switch>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>